/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

import { Component } from '@angular/core';

@Component({
	selector: 'celine-threshold-footer', 
	template: `
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-xs-6 col-sm-6 text-center">
					<p>Please contact your system admin to request access or contact support on +27 12 234 000 or email barclays@digitalsupport.co.za</p>
				</div>
			</div>
		</div>		
	`
})

export class FooterComponent {
	constructor() {}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/footer/footer.component.ts